import { URL_SURVEY_API } from "../utils/constEnvVariables";

export const getHelpDocPdf = function (accessToken, surveyCode, locale, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys";
  let requestOptions = {
          method: "GET",
          responseType: "blob",
          mode: "cors",
          cache: "default",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        };

  return fetch(`${URL_SURVEY_API}/${pathParam}/generic/${surveyCode}/helpdoc?locale=${locale}`, requestOptions).then((response) => {
    return response;
  });
};

export const getHelpDocPdfBySurveyId = function (accessToken, surveyId, locale, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys";
  let requestOptions = {
          method: "GET",
          responseType: "blob",
          mode: "cors",
          cache: "default",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        };

  return fetch(`${URL_SURVEY_API}/${pathParam}/generic/helpdoc/${surveyId}?locale=${locale}`, requestOptions).then((response) => {
    return response;
  });
};

export const uploadSurveyPartAttachments = function (file, surveyCode, assignmentId, accessToken, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let fd = new FormData();
  fd.append("file", file[0]);
  fd.append("surveyCode", surveyCode);
  fd.append("assignmentId", assignmentId);
  fd.append("fileName", file[0].name);
  const requestOptions = {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "*/*",
          },
          body: fd,
        };
  return fetch(`${URL_SURVEY_API}/${pathParam}/attachments/upload`, requestOptions);
};

export const uploadSurveyLevelAttachmentWithProgress = function (file, surveyCode, assignmentId, accessToken, isAuthMethodOkta, onProgress){
  return new Promise((resolve, reject) => {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let fd = new FormData();
  fd.append("file", file[0]);
  fd.append("surveyCode", surveyCode);
  fd.append("assignmentId", assignmentId);
  fd.append("fileName", file[0].name);

  const xhr = new XMLHttpRequest();
  xhr.open("POST", `${URL_SURVEY_API}/${pathParam}/assignment/${assignmentId}/attachments`, true);
  if (accessToken) {
    xhr.setRequestHeader("Authorization", `Bearer ${accessToken}`);
  }
  xhr.setRequestHeader("Accept", "*/*");

  xhr.upload.onprogress = (e) => {
    if(e.lengthComputable && onProgress) onProgress(Math.round((e.loaded / e.total) * 100));
  };

  xhr.onload = () => {
    if (xhr.status >= 200 && xhr.status < 300) {
      resolve(xhr.response);
    } else {
      reject(new Error(xhr.responseText || xhr.statusText || `Upload failed (${xhr.status})`));
    }
  };
  xhr.onerror = () => reject(new Error("Network error during upload"));
  xhr.send(fd);
  });
};

export const uploadHelpDoc = function (attachmentFiles, surveyCode, templateRevision, accessToken) {
  let fd = new FormData();
  const objFileNames = [];
  if(attachmentFiles){
    attachmentFiles.forEach((att) => {
        fd.append(`file_${att.docName}`, att.file);
        objFileNames.push({ languageCd: att.languageCd, fileName: att.docName });
    });
  }
  fd.append('fileNames', JSON.stringify(objFileNames));
  const requestOptions =
    {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "application/json",
          },
          body: fd,
    };
    
  return fetch(`${URL_SURVEY_API}/surveys/uploadHelpDoc/${surveyCode}&${templateRevision}`, requestOptions);
};

export function getSurveyPartAttachmentUrl(surveyCode, assignmentId, filename, accessToken, isAuthMethodOkta){
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let requestOptions = {
          method: "GET",
          responseType: "blob",
          mode: "cors",
          cache: "default",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        };


  return fetch(`${URL_SURVEY_API}/${pathParam}/attachment/url/${surveyCode}/${assignmentId}/${filename}`, requestOptions)
      .then(response => {
          return response
      })
};

export async function getPdf(surveyId, campaignId, questionId, accessToken, isAuthMethodOkta){
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys";
  const requestOptions = {
      method: 'GET',
      responseType: 'blob',
      mode: "cors",
      cache: "default",
      headers: {
          'Authorization': `Bearer ${accessToken}`,
      }
  }

  const response = await fetch(`${URL_SURVEY_API}/${pathParam}/pdf/${surveyId}&${campaignId}&${questionId}`, requestOptions);
  return response;
}


export const uploadSurveyByPartAttachments = function (file, surveyCode, campaignId, assignmentId, partId, queId, accessToken, isAuthMethodOkta) {
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  let fd = new FormData();
  fd.append("file", file[0]);
  fd.append("surveyCode", surveyCode);
  fd.append("assignmentId", assignmentId);
  fd.append("campaignId", campaignId);
  fd.append("partId", partId);
  fd.append("questionId", queId);
  fd.append("fileName", file[0].name);
  const requestOptions ={
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "*/*",
          },
          body: fd,
        };
  return fetch(`${URL_SURVEY_API}/${pathParam}/attachments/parts/upload`, requestOptions);
};

export function getSurveyByPartAttachmentUrl(fileName,surveyCode, campaignId, assignmentId, partId, queId, accessToken, isAuthMethodOkta){
  let pathParam = isAuthMethodOkta !== undefined && !isAuthMethodOkta ? "surveys-ext/nonDeere" : "surveys/generic";
  const requestOptions ={
          method: "GET",
          responseType: "blob",
          mode: "cors",
          cache: "default",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: "*/*"
          },
        };

        return fetch(`${URL_SURVEY_API}/${pathParam}/attachment/parts/url/${surveyCode}/${campaignId}/${assignmentId}/${partId}/${queId}/${fileName}`, requestOptions)
        .then(response => {
          return response
        });
    }